import React, { useEffect, useState } from "react";
import TrailerForm from "./TrailerForm";
import EmaButton from "components/emaButton/EmaButton";
import { getElements, putElement } from "services/apiEndpoints/Endpoints";
import Loading from "components/loading/Loading";
import { useTranslation } from "react-i18next";

function TrailerDetails({ setIsOpen, getVehicles, id }) {
  const { t } = useTranslation();
  const [vehicleData, setVehicleData] = useState({ plateState: "ET" });
  const [errors, setFormErrors] = useState([]);
  const [loading, setLoading] = useState(Loading);

  function handleChange(e) {
    setVehicleData({ ...vehicleData, [e.target.name]: e.target.value });
  }
  function handleSave() {
    putElement(`Authority/trailer/${id}`, vehicleData).then((res) => {
      if (res.success) {
        getVehicles();
        setIsOpen(false);
      } else if (res.vErrors) {
        setFormErrors(res.vErrors);
      }
    });
  }
  const getVehicle = () => {
    setLoading(loading);
    getElements(`Authority/trailer/${id}`).then((res) => {
      setVehicleData(res.data);
      setLoading(false);
    });
  };
  useEffect(getVehicle, []);
  return (
    <div>
      <div className="slider-header">
        <section className="slider-header-title">
          {vehicleData.unitNumber}
        </section>
        <section className="slider-header-buttons">
          <EmaButton title={t("Cancel")} onClick={() => setIsOpen(false)} />
          <EmaButton
            title={t("Save")}
            btnDark
            onClick={() => handleSave(vehicleData)}
          />
        </section>
      </div>
      <div className="slider-body">
        {loading ? (
          loading
        ) : (
          <>
            <TrailerForm
              vehicleData={vehicleData}
              handleChange={handleChange}
              errors={errors}
              carrierName={vehicleData?.carrierName || ""}
              id={id}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default TrailerDetails;
